<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont icontiku1"></i>
      评分表列表
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input v-model="name" placeholder="根据评分表名称搜索"
                    style="width: 100%">
          </el-input>
          <el-button class="margin-left-sm" type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
        <div class="flex align-center condition-warpper">
          <router-link to="/projectOffice/scoreEdit" class="margin-right">
            <el-button type="primary">
              <p class="flex align-center font-size">
                <i class="iconfont iconxinzeng margin-right-xs"></i>创建评分表
              </p>
            </el-button>
          </router-link>
          <router-link to="/projectOffice/scoreItem">
            <el-button type="primary">
              <p class="flex align-center font-size">
                <i class="iconfont iconxinzeng margin-right-xs"></i>设置评分值
              </p>
            </el-button>
          </router-link>
        </div>
      </div>
      <div class="table-warpper">
        <el-table
            :data="scoreList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="ID" width="60px">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="评分表名称">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.update_time ? scope.row.update_time : scope.row.add_time }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row.id)"
                >编辑
                </el-button>
                <el-button
                    size="medium"
                    type="success"
                    @click="copyItem(scope.row.id)"
                >复制
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                    @click="deleteItem(scope.row.id)"
                >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="scoreList.length > 0"
            class="page-all"
            background
            @current-change="setPage"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>


  </div>
</template>

<script>
import {scoreDel, scoreList,scoreCopy} from "@/api/projectOffice";

export default {
  name: "score",
  data() {
    return {
      name: '',
      scoreList: [],
      page: 1,
      total: 0,
      limit: 10,
    };
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：评分管理 > 评分表列表",
        false
    );
    if(this.$route.query.page) this.page = Number(this.$route.query.page),this.name = this.$route.query.name
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await scoreList(
          this.name,
          this.page,
          this.limit);
      this.scoreList = _list.data.list;
      this.total = _list.data.count;
    },
    setPage() {
      this.getList();
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/projectOffice/score',
        query: {
          page: this.page,
          name: this.name,
        }
      })
    },
    onSearch() {
      if(this.page === 1){
        this.setPath()
      }else{
        this.page = 1;
      }
    },
    editItem(id) {
      this.$router.push('/projectOffice/scoreEdit?id=' + id)
    },
    copyItem(id) {
      this.$confirm("确定要复制该评分表吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureCopy(id);
      });
    },
    async sureCopy(id) {
      console.log(id)
      let _state = await scoreCopy(id);
      if (this.scoreList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },

    deleteItem(id) {
      this.$confirm("确定要删除该评分表吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      console.log(id)
      let _state = await scoreDel(id);
      if (this.scoreList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    }
  },
  watch:{
    page() {
      this.setPath()
    },
    $route() {

        this.getList();

    }
  }
}
</script>

<style scoped lang="scss">

</style>